import * as React from "react";
import * as DTOS from "../../../../FeralScan.dtos";
import * as MapActionCreators from "../../../../actions/map.actions";
import * as Configuration from "../../../../configuration";
import { Map } from "../../../Map/Map";
import { changeTab } from "../../../../containers/dashboard.container";
import { MarkerIcon } from "../../../Map/Platypus/MapMarker";


export type MapLocationProps = {
    googleMapURL: string;
    lat: number;
    lng: number;
    mapMarkerComponent: any;
    marker: DTOS.Plot;
    showMarker: boolean;
}

export type MapLocationActions = {
    onBlur(): void;
    onChange(value: string): void;
    onFocus(): void;
    changeTab: changeTab;
    onMapClicked: Function;
    toggleNewMarkerPopup: typeof MapActionCreators.toggleNewMarkerPopupRequest;
}

export type MapLocationPropsAndActions = MapLocationProps & MapLocationActions;

class MapLocation extends React.PureComponent<MapLocationPropsAndActions, any> {

    render() {
        const newMarkerIcon: MarkerIcon = {
            anchor: { x: 15, y: 3 },
            path: "M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z",

            fillColor: '#DC1E1E',
            fillOpacity: 1,
            rotation: 180,
            scale: 1.5,
            strokeWeight: 0
        }

        const marker = <this.props.mapMarkerComponent
            key={`mapmarker-0`}
            icon={newMarkerIcon}
            id={0}
            interactive={false}

            popup={undefined}
            position={{ lat: this.props.lat, lng: this.props.lng }}
            isOpen={false}
            toggleMarkerPopup={undefined}
        />

        return (
            <div>
                <div className="row pb-2 map-latlong">
                    <div className="col-6">
                        <input
                            className="form-control"
                            value={this.props.lat}
                            readOnly={true}
                        />
                    </div>
                    <div className="col-6">
                        <input
                            className="form-control"
                            value={this.props.lng}
                            readOnly={true}
                        />
                    </div>
                </div>
                <div style={{ width: `100%`, paddingTop: `66.7%`, position: `relative` }} className="map-map">
                    <div style={{ position: `absolute`, top: 0, bottom: 0, left: 0, right: 0 }}>
                        <Map
                            lat={this.props.lat ? this.props.lat : Configuration.custom.defaultMapLatitude}
                            lng={this.props.lng ? this.props.lng : Configuration.custom.defaultMapLongitude}
                            defaultZoom={Configuration.custom.defaultMapMarkerZoom / 4}
                            googleMapURL={this.props.googleMapURL}
                            gridSize={30}
                            height="100%"
                            interactive={true}
                            layers={undefined}
                            mapType="normal"
                            mapTypeId={Configuration.custom.defaultMapTypeId}
                            markers={[marker]}

                            onMapClicked={(latitude: number, longitude: number) => {
                                this.props.onFocus();
                                this.props.onMapClicked(latitude, longitude);
                                this.props.onChange(`${latitude}, ${longitude}`);
                                this.props.onBlur();
                            }}
                            toggleNewMarkerPopup={this.props.toggleNewMarkerPopup}

                            zoomInOnClick={false}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default MapLocation;